<template>
  <div class="card mb-3">
    <div class="card-body">
      <div class="d-flex flex-wrap justify-content-between align-items-center mb-3">
        <h5 class="mb-0 text-uppercase" style="font-size: 13px;">Commerciaux CRM</h5>
        <button
          class="btn btn-sm btn-market"
          type="button"
          @click="showForm = !showForm"
        >
          {{ showForm ? 'Fermer' : 'Ajouter un commercial' }}
        </button>
      </div>

      <p class="small text-muted mb-3">
        Commerciaux locaux sur ce compte (pas de login séparé). Ils traitent les contacts
        affectés en choisissant leur nom comme opérateur.
      </p>

      <div v-if="showForm" class="border rounded p-3 mb-3">
        <div class="row">
          <base-input class="col-md-3" label="Prénom">
            <el-input v-model="form.prenom" />
          </base-input>
          <base-input class="col-md-3" label="Nom">
            <el-input v-model="form.nom" />
          </base-input>
          <base-input class="col-md-3" label="Email (optionnel)">
            <el-input v-model="form.email" type="email" />
          </base-input>
          <base-input class="col-md-3" label="Téléphone">
            <el-input v-model="form.telephone" />
          </base-input>
        </div>
        <button
          class="btn btn-market btn-sm"
          :disabled="!canSubmit || submitting"
          @click="submitCreate"
        >
          Enregistrer
        </button>
      </div>

      <h6 class="text-muted text-uppercase small">Actifs</h6>
      <p v-if="!(activeCommercials && activeCommercials.length)" class="text-muted small">
        Aucun commercial actif
      </p>
      <ul v-else class="list-unstyled mb-0">
        <li
          v-for="c in activeCommercials"
          :key="c.id"
          class="mb-2 d-flex flex-wrap justify-content-between align-items-center"
        >
          <div>
            <strong>{{ c.prenom }} {{ c.nom }}</strong>
            <span v-if="c.email" class="text-muted small"> — {{ c.email }}</span>
            <span v-if="c.telephone" class="text-muted small"> · {{ c.telephone }}</span>
          </div>
          <button
            type="button"
            class="btn btn-sm btn-link text-warning"
            :disabled="submitting"
            @click="$emit('disable', c)"
          >
            Désactiver
          </button>
        </li>
      </ul>

      <template v-if="disabledCommercials.length">
        <h6 class="text-muted text-uppercase small mt-3">Désactivés</h6>
        <ul class="list-unstyled mb-0">
          <li
            v-for="c in disabledCommercials"
            :key="'d-' + c.id"
            class="mb-2 d-flex flex-wrap justify-content-between align-items-center"
          >
            <div>
              <strong class="text-muted">{{ c.prenom }} {{ c.nom }}</strong>
            </div>
            <button
              type="button"
              class="btn btn-sm btn-link text-success"
              :disabled="submitting"
              @click="$emit('enable', c)"
            >
              Réactiver
            </button>
          </li>
        </ul>
      </template>
    </div>
  </div>
</template>

<script>
import { Input } from 'element-ui'

export default {
  name: 'CommercialsPanel',
  components: {
    [Input.name]: Input
  },
  props: {
    commercials: { type: Array, default: () => [] },
    submitting: { type: Boolean, default: false }
  },
  data() {
    return {
      showForm: false,
      form: { prenom: '', nom: '', email: '', telephone: '' }
    }
  },
  computed: {
    canSubmit() {
      return !!(this.form.prenom.trim() && this.form.nom.trim())
    },
    activeCommercials() {
      return (this.commercials || []).filter((c) => c.status !== 'disabled')
    },
    disabledCommercials() {
      return (this.commercials || []).filter((c) => c.status === 'disabled')
    }
  },
  methods: {
    submitCreate() {
      if (!this.canSubmit) return
      this.$emit('create', { ...this.form })
    },
    resetForm() {
      this.form = { prenom: '', nom: '', email: '', telephone: '' }
      this.showForm = false
    }
  },
  watch: {
    submitting(v, old) {
      if (old && !v) this.resetForm()
    }
  }
}
</script>
